import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=cb84b39e&scoped=true&"
import script from "./ServicePage.vue?vue&type=script&lang=js&"
export * from "./ServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84b39e",
  null
  
)

export default component.exports